// Left panel — shown when the app is NOT detected: Desktop / Mobile install flow.
import { useState } from "react";
import styles from "../Connect.module.css";
import DesktopInstall from "./DesktopInstall";
import MobileInstall from "./MobileInstall";
import { DesktopIcon, MobileIcon } from "./ConnectIcons";

const FOOTER_NOTE = "Enterprise edition · Managed by Naoris Enterprise";

const TABS = [
  { id: "desktop", label: "DESKTOP", icon: <DesktopIcon size={16} /> },
  { id: "mobile", label: "MOBILE", icon: <MobileIcon size={16} /> },
];

export default function InstallPanel() {
  const [tab, setTab] = useState("desktop");

  return (
    <section className={styles.panel}>
      <div className={styles.tabs} role="tablist">
        {TABS.map((t) => (
          <button
            key={t.id}
            type="button"
            role="tab"
            aria-selected={tab === t.id}
            className={`${styles.tab} ${tab === t.id ? styles.tabOn : ""}`}
            onClick={() => setTab(t.id)}
          >
            {t.icon}
            {t.label}
          </button>
        ))}
      </div>

      {tab === "desktop" ? <DesktopInstall /> : <MobileInstall />}

      <p className={styles.footerNote}>{FOOTER_NOTE}</p>
    </section>
  );
}
